import React, { Component } from 'react';
import './alertMessage.css';

class AlertMessage extends Component {
    constructor(props) {
        super(props);
        this.closeAlert = this.closeAlert.bind(this);
        this.state = {
            display: ""
        }
    }

    closeAlert(e) {
        this.setState({
            display: "none"
        })
    }

    render() {
        return (
            <div className="alert alert-info" style={{ display: this.state.display }}>
                <div className="messageHeader">
                    <b>What's New?</b><i className="bi bi-x" onClick={this.closeAlert}></i>
                </div>
                <ul>
                    <li>New design for podcast cards for mobile phone screens</li>
                    <li>Pagination to fetch 10 podcasts at a time</li>
                    <li>Fetch new podcasts randomly for curious listeners</li>
                    <li>Lots of code refactor :P</li>
                </ul>
                <b>What's Next?</b>
                <ul>

                    <li>Feature to write feedback</li>
                </ul>
            </div>
        );
    }
}

export default AlertMessage;
